<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
    style="left: 40%;"
========================================================================================== -->


<template>
  <div class="h-screen container" id="page-login-checker">
    <div class="col-12 col-md-10 mx-auto my-auto text-center login-wrapper">
      <h4>Preparando autenticação...</h4>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      app_token: "",
      api_url: "",
      use_microsoft_sso: false,
    };
  },
  async mounted() {
    await this.setLoginParameters();
  },
  methods: {
    async setLoginParameters() {
      this.$vs.loading({ type: "default" });
      try {
        await this.$store.dispatch("auth/getLoginParameters", {
          source_domain: window.location.origin.split("//")[1],
        });

        this.app_token = this.$store.state.auth.app_token;
        this.api_url = this.$store.state.auth.api_url;
        this.use_microsoft_sso = this.$store.state.auth.use_microsoft_sso;

        if (this.use_microsoft_sso) {
          this.$msal
            .loginRedirect({
              scopes: ["openid", "profile", "User.Read"],
              prompt: "login",
            })
            .catch((error) => {
              console.error(error);
              this.$router.push("/error-500").catch(() => {});
            });
        } else {
          this.$router.push("/login").catch(() => {});
        }
      } catch (err) {
        this.$router.push("/error-500").catch(() => {});
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>

<style src="./LoginChecker.min.css"></style>
